import React from 'react';

const Road = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 23 16" width="1em" height="1em" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path id="Road_a" d="M719.33 186.9h4.05l.42 4.39h-4.9zm3.57-4.9l.28 2.84h-3.65l.28-2.84h-3.62L710 198h8.26l.4-4.13h5.4l.4 4.13h8.25l-6.2-16z" />
    </defs>
    <use fill="currentColor" xlinkHref="#Road_a" transform="translate(-710 -182)" />
  </svg>
);

export default Road;



// WEBPACK FOOTER //
// ./src/common/icons/Road.js